import { Component, ViewChild, ElementRef, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UpdatefontsizeService } from '../../../services/updatefontsize.service';

@Component({
  selector: 'app-fontsize-modifier',
  templateUrl: './fontsize-modifier.component.html',
  styleUrls: ['./fontsize-modifier.component.scss']
})
export class FontsizeModifierComponent implements OnInit  {
 
  @Input() fontSize = 13;
  @Output() fontSizeID = new EventEmitter<any>();

  NASize  = this.fontSize;

  constructor(private updateFontSer : UpdatefontsizeService) { }    

  ngOnInit(){}


  public FontSize(type){
      if(type == '+'){
        if (this.fontSize < (this.NASize + 3)) {
          this.fontSize++;
        }
      } else if(type == '-'){
        if (this.fontSize > (this.NASize - 3)) {
          this.fontSize--;
        }
      } else{
          this.fontSize = this.NASize;
      }
      this.fontSizeID.emit(type);
      this.updateFontSer.onFontButtonClick(type);
  }

}
